import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useStore from '../../../store';
import { TEXT, STYLE } from '../constants';
import { ILinkedAccount, ISummaryData } from '../../../types';
import { LiliCheckbox, LiliCheckboxSize } from '../../../DesignSystem/LiliCheckbox/LiliCheckbox';

const {
  PAGES: {
    POST_LINKED: {
      MONEY_TRANSFER: { USER_MESSAGE },
    },
  },
} = TEXT;
const {
  PAGES: {
    POST_LINKED: {
      MONEY_TRANSFER: {
        CONFIRMATION_MODAL_CONTENT: { TRANSFER_DISCLAIMER },
      },
    },
  },
} = STYLE;

interface IProps {
  onDisclaimerChange: (mode: boolean) => void;
  linkAccountData: ILinkedAccount;
}

export const TransferDisclaimer = ({ onDisclaimerChange, linkAccountData }: IProps) => {
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const summaryData: ISummaryData = useStore((state) => state.summary);

  const name = `${summaryData.customer.firstName}  ${summaryData.customer.lastName}`;
  const { t } = useTranslation();
  const handleCheck = (checked: boolean) => {
    setIsChecked(checked);
    onDisclaimerChange(checked);
  };

  const handleDisclaimerClick = () => {
    handleCheck(!isChecked);
  };

  return (
    <div className={TRANSFER_DISCLAIMER.WRAPPER}>
      <LiliCheckbox
        id='moveMoneyTransferCheckBox'
        containerClassName='mr-[12px]'
        size={LiliCheckboxSize.MEDIUM}
        checked={isChecked}
        onCheckedChange={handleCheck}
      />
      <div
        role='button'
        onKeyDown={() => {}}
        tabIndex={0}
        onClick={handleDisclaimerClick}
        className={TRANSFER_DISCLAIMER.CONTENT}
      >
        {t(USER_MESSAGE.DISCLAIMER, {
          accountNumber: linkAccountData.routingNumber,
          userName: name,
        })}
      </div>
    </div>
  );
};
